import React, { useEffect, useRef, useState } from "react";
import "../Style/About.css";
import { useLanguage } from "../Context/Languagecontext";

import img1 from "../Assets/arun-kumar1.jpg";
import img2 from "../Assets/arun-kumar.jpg";
import img3 from "../Assets/arun-kumar10.jpeg";
import img4 from "../Assets/arun-kumar8.jpg";
import img5 from "../Assets/arun-kumar7.jpeg";
import img6 from "../Assets/arun-kumar6.jpeg";

const galleryImages = [img1, img2, img3, img4, img5, img6];

const imageTiles = [
  { id: "1", x: 0, y: 0, delay: "0.12s" },
  { id: "2", x: 1, y: 0, delay: "0.2s" },
  { id: "3", x: 2, y: 0, delay: "0.3s" },
  { id: "4", x: 0, y: 1, delay: "0.28s" },
  { id: "5", x: 1, y: 1, delay: "0.38s" },
  { id: "6", x: 2, y: 1, delay: "0.48s" },
  { id: "7", x: 0, y: 2, delay: "0.42s" },
  { id: "8", x: 1, y: 2, delay: "0.54s" },
  { id: "9", x: 2, y: 2, delay: "0.66s" },
  { id: "10", x: 0, y: 3, delay: "0.56s" },
  { id: "11", x: 1, y: 3, delay: "0.68s" },
  { id: "12", x: 2, y: 3, delay: "0.8s" },
];

const About = () => {
  const aboutRef = useRef(null);
  const { t, lang } = useLanguage();
  const a = t.about;

  const [currentImage, setCurrentImage] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          aboutRef.current?.classList.add("about--visible");
        }
      },
      { threshold: 0.2 },
    );
    if (aboutRef.current) observer.observe(aboutRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentImage((prev) => (prev + 1) % galleryImages.length);
        setFade(true);
      }, 500);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const stats = [
    {
      value: "20+",
      label: lang === "ta" ? "ஆண்டு அனுபவம்" : "Years Experience",
    },
    { value: "50K+", label: lang === "ta" ? "வாடிக்கையாளர்கள்" : "Customers" },
    { value: "100+", label: lang === "ta" ? "விற்பனையாளர்கள்" : "Dealers" },
  ];

  return (
    <section
      className={`about${lang === "ta" ? " about--tamil" : ""}`}
      id="about"
      ref={aboutRef}
    >
      <div className="about__bg-text">ABOUT</div>

      <div className="about__container">
        <div className="about__media">
          <div className="about__media-panel" aria-hidden="true" />

          <div
            className="about__media-ornament about__media-ornament--top"
            aria-hidden="true"
          />

          <div className="about__image-shell">
            <div className="about__image-frame">
              <img
                src={galleryImages[currentImage]}
                alt="About Arun Kumar"
                className={`about__image-full ${fade ? "fade-in" : "fade-out"}`}
              />

              <div className="about__image-mosaic" aria-hidden="true">
                {imageTiles.map((tile) => (
                  <span
                    key={tile.id}
                    className="about__image-tile"
                    style={{
                      "--tile-x": tile.x,
                      "--tile-y": tile.y,
                      "--tile-delay": tile.delay,
                      "--about-image": `url(${galleryImages[currentImage]})`,
                    }}
                  />  
                ))}
              </div>

              <div className="about__image-sheen" aria-hidden="true" />
            </div>
          </div>

          <div
            className="about__media-ornament about__media-ornament--bottom"
            aria-hidden="true"
          />
          <div className="about__media-accent" aria-hidden="true" />
        </div>

        <div className="about__content">
          <div className="about__eyebrow about__flow-item">
            {lang === "ta" ? "அவரது பயணம்" : "His Journey"}
          </div>

          <h2 className="about__title about__flow-item">
            {lang === "ta" ? (
              <>
                மரபின் பின்னால்<span> உள்ள மனிதர்</span>
              </>
            ) : (
              <>
                The Man Behind<span> The Legacy</span>
              </>
            )}
          </h2>

          <p className="about__desc about__flow-item">
            {lang === "ta"
              ? "திரு. அருண் குமார் பாலுசாமி அவர்கள் ஒரு தொலைநோக்கு கொண்ட தொழில்முனைவோர் மற்றும் அர்ப்பணிப்புடன் செயல்படும் அரசியல் தலைவர் ஆவார். வணிகத் திறமையையும் முன்னேற்றமான தலைமை மதிப்புகளையும் இணைத்து, தனது அர்ப்பணிப்பு, பார்வை மற்றும் சேவை மனப்பான்மையின் மூலம் வளர்ச்சி, புதுமை மற்றும் சமூகத்தில் அர்த்தமுள்ள தாக்கத்தை ஊக்குவிப்பவராக திகழ்கிறார்."
              : "Mr. Arun Kumar Balusamy is a visionary entrepreneur and dedicated political leader who combines business excellence with progressive leadership values, inspiring growth, innovation, and meaningful community impact through his commitment, vision, and service."}
          </p>

          <p className="about__desc about__flow-item">
            {lang === "ta"
              ? "KKB லுங்கி பிராண்டின் நிர்வாக இயக்குநராக, அவர் ஜவுளித் துறையில் நிறுவனத்தின் நிலையை வலுப்படுத்தியதோடு, சமூக வளர்ச்சி முயற்சிகள் மற்றும் அர்ப்பணிப்புடன் கூடிய பொது சேவை நடவடிக்கைகளுக்கும் தீவிரமாக பங்களித்து வருகிறார்."
              : "As Managing Director of KKB Lungi Brand, he has strengthened the textile industry presence while actively supporting social development initiatives and committed public service efforts."}
          </p>

          <div
            className="about__stats about__flow-item"
            role="list"
            aria-label="Leadership statistics"
          >
            {stats.map((stat) => ( 
              <div className="about__stat" key={stat.label} role="listitem">
                <h3>{stat.value}</h3>
                <p>{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
